// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wHOdL","clinicsSelect":"styles_clinicsSelect__Rh_7l"};